const { NODE_ENV = "" } = process.env;

const environment = NODE_ENV.toLowerCase();
// console.log(environment);
// window.location.hostname !== 'release.tractionapps.co'  &&

const apiUrl = 'https://static.tractionapps.co';
const fcmbData = {};
export { environment, apiUrl };
